// eslint-disable-next-line import/no-cycle
import cdo from '@client/util/router/cdo';
// eslint-disable-next-line import/no-cycle
import cms from '@client/util/router/cms';
// eslint-disable-next-line import/no-cycle
import dashboardAccess from '@client/util/router/dashboardAccess';
// eslint-disable-next-line import/no-cycle
import auth from '@client/util/router/auth';
// eslint-disable-next-line import/no-cycle
import initiateLoadingSpinner from '@client/util/router/initiateLoadingSpinner';
// eslint-disable-next-line import/no-cycle
import loadLayout from '@client/util/router/loadLayout';
// eslint-disable-next-line import/no-cycle
import clientInfoSetup from '@client/util/router/clientInfoSetup';
// eslint-disable-next-line import/no-cycle
import maintenance from '@client/util/router/maintenance';
import redirectRiaUsersToAdvisor from '@client/util/router/redirectRiaUsersToAdvisor';

export default [
  maintenance,
  initiateLoadingSpinner,
  redirectRiaUsersToAdvisor,
  cms,
  loadLayout,
  auth,
  cdo,
  clientInfoSetup,
  dashboardAccess,
];
